/**
 * ErrorMessage
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon/Icon';
import Button from './../Button/Button';

const ErrorMessage = (props) => {
  const {
    title,
    message,
    renderMessage,
    icon,
    retry,
    types,
  } = props;

  const typeClasses = types.map(type => `error-message--${type}`);
  const className = classNames('error-message', ...typeClasses);

  return (
    <div className={className}>
      <Icon name={icon} />
      <h3>{title}</h3>
      <div className="error-message__message">
        {renderMessage ? renderMessage() : message }
      </div>
      {retry && (
        <Button
          onClick={retry}
          types={['whiteout']}
        >
          Retry
        </Button>
      )}
    </div>
  );
};

ErrorMessage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  icon: PropTypes.string,
  retry: PropTypes.func,
  types: PropTypes.arrayOf(PropTypes.string.isRequired),
};

ErrorMessage.defaultProps = {
  title: 'An Error occurred',
  message: 'Unfortunately the data could not be loaded.',
  icon: 'warning',
  types: [],
};

export default ErrorMessage;
